import React, { Component } from "react";
import { connect } from "react-redux";
import ListItem from "./ListItem";
import MList from "@material-ui/core/List";
import Category from "./Category";
import { Sticky, StickyContainer } from "react-sticky";

export class List extends Component {
  render() {
    const ios =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    let insta = navigator.userAgent.match(/instagram/i);
    insta = false;
    let offset = 54;
    let PCOffset = 0;
    if (ios && insta) offset += 43;
    let products = [];

    this.props.category.products.forEach((product) => {
      if (
        !this.props.filter ||
        (this.props.filter &&
          (product.product.name
            .toLowerCase()
            .includes(this.props.filter_value.toLowerCase()) ||
            product.product.ar_name
              .toLowerCase()
              .includes(this.props.filter_value.toLowerCase())))
      ) {
        return products.push(
          <ListItem
            product={product.product}
            isSearch={this.props.filter}
            filter_value={this.props.filter_value}
            productInfo={product}
            showPrices={this.props.showPrices}
            key={"ListItem_Menu" + product.product.id}
            category={this.props.category}
          />
        );
      }
    });

    if (products.length) {
      return (
        <StickyContainer>
          <Sticky
            topOffset={this.props.isMobile ? -offset : -PCOffset}
            bottomOffset={this.props.isMobile ? offset : PCOffset}
          >
            {({ style }) => {
              if (style.top < 50) {
                if (this.props.isMobile) {
                  style.top += offset;
                } else {
                  style.top += PCOffset;
                }
              }

              return (
                <Category
                  id={this.props.category.id}
                  style={{ ...style, zIndex: 1 }}
                  onClick={this.props.onClick}
                  language={this.props.language}
                  min_order={
                    this.props.category.products[0].minimum_order_value
                  }
                  settings={this.props.settings}
                  text={
                    this.props.language == "english"
                      ? this.props.category.category_name
                      : this.props.category.category_ar_name
                  }
                />
              );
            }}
          </Sticky>
          <MList
            id={"nav" + this.props.category.id}
            component="nav"
            aria-label="main mailbox folders"
            style={{
              width: "100%",
              backgroundColor: "white",
              paddingBottom: 8,
              paddingTop: 8,
            }}
          >
            {products}
          </MList>
        </StickyContainer>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  language: state.store.language,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(List);
